import L from 'leaflet';

interface AnimateMarkerOptions {
  duration?: number;
  easing?: (t: number) => number;
}

const easeInOutQuad = (t: number): number => {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};

export const animateMarker = (
  marker: L.Marker,
  newLatLng: L.LatLngExpression,
  options: AnimateMarkerOptions = {}
): void => {
  const { duration = 2000, easing = easeInOutQuad } = options;

  const startLatLng = marker.getLatLng();
  const endLatLng = L.latLng(newLatLng);

  if (startLatLng.equals(endLatLng)) {
    return;
  }

  const startTime = performance.now();

  const animate = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easing(progress);

    const lat =
      startLatLng.lat + (endLatLng.lat - startLatLng.lat) * easedProgress;
    const lng =
      startLatLng.lng + (endLatLng.lng - startLatLng.lng) * easedProgress;

    marker.setLatLng([lat, lng]);

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  };

  requestAnimationFrame(animate);
};
